import { LineItemCreateButton } from "./line-item.create.button";
import { LineItemCreateForm } from "./line-item.create.form";

export const LineItemCreate = {
    Button: LineItemCreateButton,
    Component: LineItemCreateForm,
}
